module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Site Page Favorities */

(function(fox) {
	
	fox.registerWidget('SitePage_Favorites', {

		//init: function() {
			// this.currentId = fox.Navigator.get(1);
			// this.userId = fox.site.member.getObjectValue('id');
			
			// this.favoriteDl = fox.createDataLayer()
			// 	.setClass('Content_Favorite')
			// 	.addFields(['id', 'contentId'])
			// 	.addFilter(['userId'], [this.userId])
			// 	.addMetaField('resources', {primary: 'primary..w282i', photoSet: 'primary..w135i',  photoSetCount: 'sources..w140i'})
			// 	.addMetaField('contents')
			// 	.setLimit(25);

			// this.embedWidget('favorites', 'Grid', {
			// 	container: '#favorites', 
			// 	dataLayer: this.favoriteDl,
			// 	preset: 'favorites',
			// 	autoRender: true,
			// 	externalLoad: true,
			// 	list: {
			// 		tpl: {
			// 			row: fox.getTemplate('sitepage_favorites_row'),
			// 		},
			// 		handlers: {
			// 			showCross: {
			// 				target: '.favitem',
			// 				event: 'mouseover',
			// 				callback: fox.bind(this.showCross, this)
			// 			},
			// 			hideCross: {
			// 				target: '.favitem',
			// 				event: 'mouseout',
			// 				callback: fox.bind(this.hideCross, this)
			// 			},
			// 			remove:{
			// 				target: '.remove',
			// 				event: 'click',
			// 				callback: fox.bind(this.remove, this)
			// 			}

			// 		},
			// 		hooks: {
			// 			onAddedToDom: fox.bind(function(obj) {
			// 				this.imageLoaded();
			// 			}, this),
			// 		}
			// 	},
				/*pager: {
					container: '#join_continue',
					zenTemplate: '',
					tpl: {
						container: fox.getTemplate('pagerLogged')
					},
					currentPageClass: 'cp',
					page: '',
					pagesCount: 3,
					handlers: {
						setPage: {
							target: '.pager-click'
						}
					},
					navigatorPrefix: 'fovorite_page'
				}*/
			// });
			
		// 	return this.callParent('init', arguments);
		// },

		// running: function() {
		// 	this.handleEvent(fox.Navigator, 'modified_0', fox.bind(this.runFavorites, this), true);
		// },
		
		// runFavorites: function() {
		// 	this.favoriteDl.load();
		// },

		// imageLoaded: function() {
		// 	var self = this;
		// 	var favicons = fox.dom.select('.favitem', this.element);
			
		// 	$(favicons).each(function(i, el) {
		// 		var elt = $(el).find('img')[0];
		// 		elt.onload = function(){
		// 			self.initFavorites();
		// 		}
		// 	});
		// },

		// initFavorites: function(elt) {
		// 	setTimeout(function() { 
		// 		$('#favorites').masonry({
		// 			// options
		// 			itemSelector : '.favitem',
		// 			columnWidth: function( containerWidth ) {
		// 				return containerWidth / 6;
		// 			},
		// 			isAnimated: true,
		// 			animationOptions: {
		// 				duration: 750,
		// 				easing: 'linear',
		// 				queue: false
		// 			}
		// 		});
		// 	}, 200)
		// },

		// showCross: function(elt){
		//  	$(elt).find('.remove').show();
		// },

		// hideCross: function(elt){
		//  	$(elt).find('.remove').hide();
		// },

		// remove: function(elt){
		// 	this.favoriteElt = $(elt).parent();
		// 	if (elt.id) {
		// 		var data = {
		// 			'contentId': elt.id
		// 		};

		// 		var api = new fox.Api(null, this._wom).method('favorite.toggle');
		// 		this.handleEvent(api, ['success'], fox.bind(this.response, this));
		// 		api.send(data);
		// 	}
		// },

		// response: function(data) {
		// 	if (data.answer.response.success) {
		// 		var response = data.answer.response.success;
		// 		if (!response.is) {
		// 			this.favoriteElt.remove();
		// 			$('#favorites').masonry('reload')
		// 		}	
		// 	}	
		// }
		// activate: function() {
		// 	this.callParent('activate', arguments);
		// 	this.requireEmbeddedWidget('favorites').dl.load()
		// }
	}, 'Site_Page');
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/sitepage/favorites.js
// module id = 1260
// module chunks = 4